import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../context/auth/auth.context";
import { useTranslation } from "react-i18next"; // ✅ import
import AideaLogo from "../../images/AideaLogo.png";

const Login = () => {
  const { t } = useTranslation(); // ✅ hook
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [formError, setFormError] = useState("");
  const { login, loading } = useAuth();
  const history = useHistory();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = formData;

    if (!username || !password) {
      setFormError(t("formErrorEmpty"));
      return;
    }

    try {
      const success = await login(username, password);
      if (success) history.push("/");
    } catch {
      setFormError(t("formErrorInvalid"));
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <div className="authincation-content p-4 shadow-lg rounded-3 bg-white" style={{ width: "100%", maxWidth: "450px" }}>
        <div className="text-center mb-4">
          <img src={AideaLogo} alt="Logo" width="50" />
          <h4 className="mt-3">{t("signIn")}</h4>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label><strong>{t("username")}</strong></label>
            <input
              type="text"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
              placeholder={t("enterUsername")}
            />
          </div>

          <div className="form-group mb-4">
            <label><strong>{t("password")}</strong></label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
              placeholder={t("enterPassword")}
            />
          </div>

          {formError && <div className="alert alert-danger py-2 text-center">{formError}</div>}

          <div className="text-center">
            <button type="submit" className="btn btn-primary btn-block w-100" disabled={loading}>
              {loading ? t("loggingIn") : t("login")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
